var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.792 31.134l19.342-19.342M27.56 28.532V11.657H10.685",
    stroke: "#000",
    strokeWidth: 3
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzkiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCAzOSA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNzkxOTkgMzEuMTM0TDI4LjEzNDIgMTEuNzkxOSIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIzIi8+CjxwYXRoIGQ9Ik0yNy41NjAxIDI4LjUzMkwyNy41NjAxIDExLjY1NzJMMTAuNjg1MiAxMS42NTcyIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjMiLz4KPC9zdmc+Cg==";
export { SvgArrowLink as ReactComponent };